import { autoinject, transient } from 'aurelia-dependency-injection';
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
@transient()
export class DeleteModal {
    public vm: any;

    constructor(private dialogClient: DialogClientService) { }

    activate(vm: any) {
        this.vm = vm;
    }

    yes() {
        return new Promise<void>((resolve, reject) => {
            try {
                const response = this.vm.delete();
                if (response instanceof Promise) {
                    response.then(() => {
                        resolve();
                    }).catch(() => {
                        reject();
                    })
                } else {
                    resolve();
                }
            } catch (e) {
                reject();
            }
        });
    }

    no() {
        this.dialogClient.hide();
    }
}
